import { ApiQueryParams, DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';
import { getCorrectTranslation } from '@frontend/lang';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { Card, CardProps } from '../card/card.component';
import useCardList from './card-list.controller';

export interface CardListProps<T extends { id: string } & object> {
    type: EntityType;
    dispatch: ThunkDispatch<any, any, Action>;
    fetch: (arg?: ApiQueryParams<DefaultQueryParams | string | number>) => Promise<PaginatedResponse<T>>;
    useStaticListId?: boolean;
    eventListener?: EntityType;
    id?: string;
    listStoreIdCallback?: (id: string) => void;
    onSelectCard?: (item: T) => void;
    cardOptions?: (item: T) => Partial<CardProps<T>>;
}

export const CardList = <T extends { id: string; name: string; description: string | null; type?: string | undefined }>(props: CardListProps<T>) => {
    const viewProps = useCardList<T>(props);

    return viewProps.data ? (
        <div className='grid grid-cols-1 items-start gap-3 self-stretch md:grid-cols-2 lg:grid-cols-3'>
            {viewProps.data.map((item) => {
                return (
                    <Card
                        {...(props.cardOptions ? props.cardOptions(item) : {})}
                        key={item.id}
                        id={item.id}
                        item={item}
                        title={() => getCorrectTranslation(viewProps.locale, item, 'name')}
                        description={item.description ? getCorrectTranslation(viewProps.locale, item, 'description') : ''}
                        onClick={() => (props.onSelectCard ? props.onSelectCard(item) : undefined)}
                    />
                );
            })}
        </div>
    ) : (
        <div>Loading...</div>
    );
};
